module.exports = __webpack_public_path__ + "img/undraw_laravel_and_vue_59tp.55438caf.svg";